import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Vendor } from '../vendor/vendor';
import { VendorService } from '../vendor/vendor.service';
import { ArticleService } from '../article/article.service';
import { Article } from '../article/article';
import { Receipt, ReceiptPos } from '../receipt/receipt';
import { ReceiptService } from '../receipt/receipt.service';
import { Message, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-receipt-detail',
  templateUrl: './receipt-detail.component.html',
  styleUrls: ['./receipt-detail.component.css']
})
export class ReceiptDetailComponent implements OnInit {

  receipt: Receipt;
  msgs: Message[];
  private isEdit: boolean;
  articleList: SelectItem[];
  vendorList: SelectItem[];
  articleDescr : string[];
  selectedPosition :  ReceiptPos;


  constructor(private route: ActivatedRoute, private router: Router,
    private receiptService: ReceiptService, private vendorService: VendorService,
    private articleService: ArticleService) {
    this.receipt = new Receipt();
    this.msgs = [];
    this.isEdit = false;
    this.articleList = [{label:"Auswahl",value:""}];
    this.vendorList = [];
    this.receipt.vendorid = 0;
    this.receipt.state = 10;
    this.receipt.created = new Date();
    this.articleDescr = [];
  }

  ngOnInit() {
    // Here we go, we need to check if there was an id passed. if so, we 
    // have to query receipt details to enable edit of receipt.
    if (this.route.snapshot.params['id'] != null) {
      this.receiptService.qryReceipt(+this.route.snapshot.params['id']).subscribe(
        (receipt: Receipt) => {
          if (receipt != null) {
            this.receipt = receipt;
            this.isEdit = true;
          } else {
            this.msgs.push({ severity: 'warn', summary: 'Failed to load receipt.' });
          }
        },
        (err) => {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Failed to load receipt.' })
        }
      );
    }

    // Load vendors for select menue
    this.vendorService.list().subscribe(
      (vendorList: Vendor[]) => {
        if (vendorList != null) {
          for (var vendor of vendorList) {
            this.vendorList.push({ value: vendor.id, label: vendor.vendorid + ' - ' + vendor.name1 });
          }
        } else {
          console.log("Couldn't load vendors. Please contact customer support.");
        }
      },
      (err) => {
        console.log("Couldn't load vendors. Please contact customer support.");
        console.log(err);
      }
    );
    // Load articles for select menue
    this.articleService.list().subscribe(
      (articleList: Article[]) => {
        if (articleList != null) {
          for (var article of articleList) {
            let item: SelectItem = { value: article.id, label: article.articleNumber + ' - ' };
            /**
             * Select correct descript for article name 1.
             * At this point we only have a default description,
             * so that simply this is selected.
             */
            for (var descr of article.descr) {
              if (descr.langCode == 'def') {
                item.label = item.label + descr.name1;
                this.articleDescr[article.id] = item.label;
              }
            }
            this.articleList.push(item);
          }
        } else {
          console.log("Couldn't load vendors. Please contact customer support.");
        }
      },
      (err) => {
        console.log("Couldn't load vendors. Please contact customer support.");
        console.log(err);
      }
    );
  }



  /**
   * Saves receipt.
   */
  public onSubmit() {
    if (!this.isEdit) {
      this.receiptService.save(this.receipt).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Wareneingang wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/receipt');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Wareneingang konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save receipt, error msg: ' + err);
        }
      );
    } else {
      // set updated date to current date
      this.receipt.updated = new Date();

      this.receiptService.update(this.receipt).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Wareneingang wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/receipt');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Wareneingang konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save receipt, error msg: ' + err);
        }
      );
    }
  }

  public addPosition() {
    if (this.receipt.positions == null)
      this.receipt.positions = [];
    let pos: ReceiptPos = new ReceiptPos();
    pos.userid = this.receipt.userid;
    pos.version = 0;
    pos.receipt = this.receipt.receipt;
    pos.id = 0;
    pos.articleid = 0;
    pos.state = 10;
    pos.created = new Date();
    pos.updated = new Date();
    pos.pos = 1+'';

    /**
     * Get maximum value of pos. and add one
     */
    for (var p of this.receipt.positions) {
      if(+p.pos >= +pos.pos)
        pos.pos = (+p.pos + 1)+'';
    }

    this.receipt.positions = [...this.receipt.positions, pos];
  }

  private equalPositions(p1: ReceiptPos, p2 :ReceiptPos) : boolean {
    return p1.id == p2.id && p1.articleid == p2.articleid && p1.pos == p2.pos && p1.qtyExpected == p2.qtyExpected
      && p1.qtyReceived == p2.qtyReceived && p1.receipt == p2.receipt && p1.reservationCode == p2.reservationCode 
      && p1.userid == p2.userid && p1.version == p2.version && p1.state == p2.state;
  }

  public deleteSelectedPosition() {
    if(this.selectedPosition == null)
    {
      this.msgs = [];
      let msg: Message = { severity: 'info', summary: 'Keine Auswahl.', detail: 'Es wurde keine Position ausgewaehlt.' };
      this.msgs.push(msg);
      return;
    }

    let posArray : ReceiptPos[] = [];
    for(var pos of this.receipt.positions)
    {
      if(!this.equalPositions(pos, this.selectedPosition)) {
        posArray.push(pos);
      }
    }
    this.receipt.positions = posArray;
    this.selectedPosition = null;
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/receipt-detail/receipt-detail.component.ts